module.exports = __webpack_public_path__ + "img/item-04.8f085934.png";